import React, { useEffect, useState } from "react";
import "./LoginSignup.css";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";

import * as utils from "../../global/utils";
import * as Helpers from "../../global/Helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import OtpPopup from "../popups/OtpPopup/OtpPopup";
import i18next from "i18next";
import checkMarkCorrect from "../../assets/icons/ic-check-mark-correct.png";
import checkMarkFalse from "../../assets/icons/ic-check-mark-x.png";
import { format } from "react-string-format";

import SpinnersLoadingSIP from "../SpinnersLoadingSIP/SpinnersLoadingSIP";

toast.configure();
function ForgetPassword() {
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");

  const [username, setUsername] = useState("");
  const [nin, setNin] = useState("");
  const [qId, setQId] = useState("");
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [NewPasswordType, setNewPasswordType] = useState("password");
  const [ConfirmPasswordType, setConfirmPasswordType] = useState("password");

  const [visible, setVisible] = useState(false);

  const [MINLENGTH, set_MINLENGTH] = useState("");
  const [ENFORCE_START_WITH_ALPHA, set_ENFORCE_START_WITH_ALPHA] = useState("");
  const [ENFORCE_SPECIAL_CHAR, set_ENFORCE_SPECIAL_CHAR] = useState("");
  const [ENFORE_ALPHANUMERIC, set_ENFORE_ALPHANUMERIC] = useState("");
  const [NUM_SMALL_CHAR, set_NUM_SMALL_CHAR] = useState("");
  const [NUM_SPECIAL_CHAR, set_NUM_SPECIAL_CHAR] = useState("");
  const [NUM_CAPITAL_CHAR, set_NUM_CAPITAL_CHAR] = useState("");
  const [IC_MINLENGTH, set_IC_MINLENGTH] = useState(checkMarkFalse);
  const [IC_ENFORCE_START_WITH_ALPHA, set_IC_ENFORCE_START_WITH_ALPHA] =
    useState(checkMarkFalse);
  const [IC_ENFORCE_SPECIAL_CHAR, set_IC_ENFORCE_SPECIAL_CHAR] =
    useState(checkMarkFalse);
  const [IC_ENFORE_ALPHANUMERIC, set_IC_ENFORE_ALPHANUMERIC] =
    useState(checkMarkFalse);
  const [IC_NUM_SMALL_CHAR, set_IC_NUM_SMALL_CHAR] = useState(checkMarkFalse);
  const [IC_NUM_CAPITAL_CHAR, set_IC_NUM_CAPITAL_CHAR] =
    useState(checkMarkFalse);
  const [IC_NUM_SPECIAL_CHAR, set_IC_NUM_SPECIAL_CHAR] =
    useState(checkMarkFalse);

  let leftLocalized = "left";
  let mr2Localized = "mr-2";

  if (i18next.language === "ar") {
    leftLocalized = "right";
    mr2Localized = "ml-2";
  }
useEffect(() => {
  const method = localStorage.getItem("ForgotPasswordMethod");

  // if method is missing (refresh / direct link), go back to login
  if (!method || method === "" || method === "null" || method === "undefined") {
    setRedirect(AppUrls.login);
    return;
  }
}, []);

  function validate() {
    if (!isNewPasswordVisible) {
      if (localStorage.getItem("ForgotPasswordMethod") === "S") {
        if (
          localStorage
            .getItem(Constants.localStorageConstants.company_name)
            .toUpperCase() === "IFS"
        ) {
          if (username.length === 0 || username === "" || username === null) {
            Helpers.errorNotify(
              t("Please_enter_username_and_try_again."),
              i18next.language
            );
            return false;
          }
        }
        if (email.length === 0 || email === "" || email === null) {
          Helpers.errorNotify(t("emailisrequired"), i18next.language);
          return false;
        }

        if (mobile.length === 0 || mobile === "" || mobile === null) {
          Helpers.errorNotify(t("mobileRequired"), i18next.language);
          return false;
        }
      } else if (localStorage.getItem("ForgotPasswordMethod") === "O") {
        if (nin.length === 0 || nin === "" || nin === null) {
          Helpers.errorNotify(
            t("Trading_Number_is_required"),
            i18next.language
          );
          return false;
        }

        if (mobile.length === 0 || mobile === "" || mobile === null) {
          Helpers.errorNotify(t("mobileRequired"), i18next.language);
          return false;
        }
      } else if (
        localStorage.getItem("ForgotPasswordMethod") === "U" ||
        localStorage
          .getItem(Constants.localStorageConstants.company_name)
          .toUpperCase() === "SIFS"
      ) {
        if (username.length === 0 || username === "" || username === null) {
          Helpers.errorNotify(
            t("Please_enter_username_and_try_again."),
            i18next.language
          );
          return false;
        }
      }
      else if (
        localStorage.getItem("ForgotPasswordMethod") === "C"
      ) {

        if (nin.length === 0 || nin === "" || nin === null) {
          Helpers.errorNotify(t("NIN_is_required"), i18next.language)
          return false;
        }

        if (qId.length === 0 || qId === "" || qId === null) {
          Helpers.errorNotify(t("QID_is_required"), i18next.language)
          return false;
        }
      }
      else if (
        localStorage.getItem("ForgotPasswordMethod") === "UE"
      ) {
        if (username.length === 0 || username === "" || username === null) {
          Helpers.errorNotify(
            t("Please_enter_username_and_try_again."),
            i18next.language
          );
          return false;
        }
        if (email.length === 0 || email === "" || email === null) {
          Helpers.errorNotify(t("emailisrequired"), i18next.language);
          return false;
        }
      }
      else {
        // if (nin.length === 0 || nin === "" || nin === null) {
        //     Helpers.errorNotify(t("NIN_is_required"), i18next.language)
        //     return false;
        // }



        if (email.length === 0 || email === "" || email === null) {
          Helpers.errorNotify(t("emailisrequired"), i18next.language);
          return false;
        }

        if (mobile.length === 0 || mobile === "" || mobile === null) {
          Helpers.errorNotify(t("mobileRequired"), i18next.language);
          return false;
        }
      }
    }
    //else {
    //     if (newPassword.length === 0 || newPassword === "" || newPassword === null) {
    //         Helpers.errorNotify(t("New_Password_is_required"), i18next.language)
    //         return false;
    //     }

    //     if (confirmNewPassword.length === 0 || confirmNewPassword === "" || confirmNewPassword === null) {
    //         Helpers.errorNotify(t("Confirm_New_Password_is_required"), i18next.language)
    //         return false;
    //     }

    //     if (confirmNewPassword !== newPassword) {
    //         Helpers.errorNotify(t("passwordnotmatchconfirmedpassword"), i18next.language)
    //         return false;
    //     }
    // }
    return true;
  }

  function callRegistrationsOTP(onClose, otp) {
    setVisible(false);

    if (otp.length === 0) {
      Helpers.errorNotify(t("OTP_required"), i18next.language);
      return;
    }

    ;
    var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
    if (
      DeviceConfigs !== null &&
      DeviceConfigs !== undefined &&
      localStorage
        .getItem(Constants.localStorageConstants.company_name)
        .toUpperCase() === "SIFS"
    ) {
      if (Number(DeviceConfigs.Tokenlength) !== otp.length) {
        if (Number(DeviceConfigs.Tokenlength) < otp.length) {
          var msg =
            i18next.language === "ar"
              ? " لا ينبغي أن يكون الرمز المؤقت أكثر من " +
              Number(DeviceConfigs.Tokenlength) +
              " خانات "
              : "OTP should not be more than " +
              Number(DeviceConfigs.Tokenlength) +
              " digits";
          Helpers.errorNotify(msg, i18next.language);
        } else if (Number(DeviceConfigs.Tokenlength) > otp.length) {
          var msg =
            i18next.language === "ar"
              ? " لا ينبغي أن يكون الرمز المؤقت أقل من " +
              Number(DeviceConfigs.Tokenlength) +
              " خانات "
              : "OTP should not be less than " +
              Number(DeviceConfigs.Tokenlength) +
              " digits";
          Helpers.errorNotify(msg, i18next.language);
        }
        return false;
      }
    }

    setVisible(false);
    var isIPOQuickSell =
      localStorage
        .getItem(Constants.localStorageConstants.EnableIPOQuickSell)
        .toUpperCase() === "TRUE"
        ? "Y"
        : "N";

    let registrationsOTPResponse = utils.registrationsOTP(
      localStorage.getItem("username"),
      otp,
      "",
      "",
      "",
      "",
      "Y",
      isIPOQuickSell
    );

    registrationsOTPResponse
      .then((response) => {
        // console.log("registrationsOTPResponse: ", response);
        let status = response.data["Status"];
        ;
        if (response.data["Status"] === "0") {
          setVisible(false);
          //successNotify(t("passwordReset"));
          if (localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "BHM") {
            Helpers.successNotify(response.data["ErrorMsg"], i18next.language);
            setRedirect(AppUrls.login);
          } else {
            setIsNewPasswordVisible(true);
          }

          onClose();
        } else if (response.data["Status"] === "") {
        } else {
          //   if (localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "SIFS") {
          //     thisParam.setState({ otp: "" });
          //   }
          Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
        }
      })
      .catch((error) => {
        setVisible(false);
        //console.log("callRegistrationsOTP error", error);
        Helpers.errorNotify(error.message, i18next.language);
      });
  }

  function otpPrompt() {
    confirmAlert({
       closeOnClickOutside: false,   
    closeOnEscape: false,  
      customUI: ({ onClose }) => {
        return (
          <OtpPopup
            onClose={onClose}
            callRegistrationsOTP={callRegistrationsOTP}
          />
        );
      },
    });
  }

  function callUserAuthinticationAdvance() {
    if (!validate()) {
      return;
    }
    setVisible(true);
    // let requestType = localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS" ? "S" : "C";
    let requestType = "";

    // if (localStorage.getItem(Constants.localStorageConstants.company_name) === "IFS") {
    //     requestType = "S"
    // }
    // else if (localStorage.getItem(Constants.localStorageConstants.company_name) === "GLOBAL") {
    //     requestType = "O"
    // }
    // else {
    //     requestType = "C"
    // }
    ;
    let response = utils.userAuthinticationAdvance(
      "Etrade",
      "192.168.26.1",
      nin,
      qId,
      mobile,
      email,
      requestType,
      username
    );
    //console.log(response);
    response
      .then((response) => {
        setVisible(false);
        // console.log("userAuthinticationAdvance: ", response);
        if (
          response.data.PasswordPolicy !== null &&
          response.data.PasswordPolicy !== undefined &&
          Object.keys(response.data.PasswordPolicy).length !== 0
        ) {
          set_MINLENGTH(response.data.PasswordPolicy["MINLENGTH"]);
          set_ENFORCE_START_WITH_ALPHA(
            response.data.PasswordPolicy["ENFORCE_START_WITH_ALPHA"]
          );
          set_ENFORCE_SPECIAL_CHAR(
            response.data.PasswordPolicy["ENFORCE_SPECIAL_CHAR"]
          );
          set_ENFORE_ALPHANUMERIC(
            response.data.PasswordPolicy["ENFORE_ALPHANUMERIC"]
          );
          set_NUM_SMALL_CHAR(response.data.PasswordPolicy["NUM_SMALL_CHAR"]);
          set_NUM_CAPITAL_CHAR(
            response.data.PasswordPolicy["NUM_CAPITAL_CHAR"]
          );
          set_NUM_SPECIAL_CHAR(
            response.data.PasswordPolicy["NUM_SPECIAL_CHAR"]
          );
        }

        let status = response.data["Status"];
        switch (status) {
          case Constants.LoginStatus.Success:
            localStorage.setItem("username", response.data["UserName"]);
            localStorage.setItem("WebCode", response.data["WebCode"]);
            otpPrompt();
            break;
          case "-1":
            localStorage.getItem("ForgotPasswordMethod") === "S"
              ? Helpers.errorNotify(
                t("InvalidEmailorMobileNo"),
                i18next.language
              )
              : localStorage.getItem("ForgotPasswordMethod") === "O"
                ? Helpers.errorNotify(t("InvalidNINorMobileNo"), i18next.language)
                : localStorage.getItem("ForgotPasswordMethod") === "U" ||
                  localStorage
                    .getItem(Constants.localStorageConstants.company_name)
                    .toUpperCase() === "SIFS"
                  ? Helpers.errorNotify(t("invalidregistrationInformation"), i18next.language)
                  : localStorage.getItem("ForgotPasswordMethod") === "C" ?
                    Helpers.errorNotify(t("incorrect_nin_qid"), i18next.language)

                    : localStorage.getItem("ForgotPasswordMethod") === "UE" ?
                      Helpers.errorNotify(t("incorrect_Username_Email"), i18next.language)


                      : Helpers.errorNotify(
                        t("InvalidEmailorMobileNo"),
                        i18next.language
                      );
            break;
          case Constants.LoginStatus.ExceedNoTrials:
            Helpers.errorNotify(t("userLocked"), i18next.language);
            break;
          case "":
            break;
          default:
            // errorNotify("error has occured")
            Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            break;
        }
      })
      .catch((error) => {
        setVisible(false);
        console.log("error", error);
        Helpers.errorNotify(error.message, i18next.language);
      });
  }

  function callResetPassword() {
    if (!validateForResetPassword()) {
      return;
    }
    setVisible(true);
    let response = utils.resetPasswordAdvance(
      mobile,
      email,
      utils.encryptedString(newPassword),
      "",
      "Etrade",
      "192.168.26.1",
      "",
      localStorage.getItem("username"),
      nin,
      qId
    );
    //console.log(response);
    response
      .then((response) => {
        setVisible(false);

        // console.log("userAuthinticationAdvance: ", response);
        let status = response.data["Status"];
        localStorage.setItem(
          "isTermsAndConditions",
          response.data["isTermsAndConditions"]
        );

        switch (status) {
          case Constants.LoginStatus.Success:
            //
            // if (response.data["isTermsAndConditions"] === "N" && localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS") {
            //     setRedirect(AppUrls.TermsAndConditions);
            // }
            // else {
            Helpers.successNotify(t("ChangePasswordMsg"), i18next.language);
            setRedirect(AppUrls.trading);
            // }
            break;
          default:
            Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            break;
        }
      })
      .catch((error) => {
        setVisible(false);
        console.log("error:", error);
        Helpers.errorNotify(error.message, i18next.language);
      });
  }

  let hideLoader = "";
  if (visible) {
    hideLoader = "";
  } else {
    hideLoader = "hide-loader";
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  function onChangeNewPassword(e) {
    var Newpassword = e.target.value;
    setNewPassword(e.target.value);
    if (
      Newpassword.length >= parseInt(MINLENGTH) &&
      IC_MINLENGTH === checkMarkFalse
    ) {
      set_IC_MINLENGTH(checkMarkCorrect);
    }

    if (
      Newpassword.length < parseInt(MINLENGTH) &&
      IC_MINLENGTH === checkMarkCorrect
    ) {
      set_IC_MINLENGTH(checkMarkFalse);
    }

    if (Newpassword.length > 0) {
      if (Newpassword.charAt(0) <= "9" && Newpassword.charAt(0) >= "0")
        set_IC_ENFORCE_START_WITH_ALPHA(checkMarkFalse);
      else set_IC_ENFORCE_START_WITH_ALPHA(checkMarkCorrect);

      let specialFormat =
        localStorage.getItem(Constants.localStorageConstants.company_name) ===
          "ALRAMZ"
          ? /[!$@%#]/
          : /[~!@#$*]/;
      let containsSpecialChar = false;
      if (specialFormat.test(Newpassword)) {
        containsSpecialChar = true;
      }

      if (
        localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "ALRAMZ"
      ) {
        const specialChars = /[`*^&()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (specialChars.test(Newpassword)) {
          containsSpecialChar = false;
        } else {
          containsSpecialChar = true;
        }
      }

      let numberFormat = /\d/;
      let containsNumberChar = false;
      if (numberFormat.test(Newpassword)) {
        containsNumberChar = true;
      }

      let stringFormat = /[a-zA-Z]/;
      let containsletterChar = false;
      if (stringFormat.test(Newpassword)) {
        containsletterChar = true;
      }

      if (containsSpecialChar && containsNumberChar && containsletterChar)
        set_IC_ENFORCE_SPECIAL_CHAR(checkMarkCorrect);
      else set_IC_ENFORCE_SPECIAL_CHAR(checkMarkFalse);


      if (containsNumberChar )
        set_IC_ENFORE_ALPHANUMERIC(checkMarkCorrect);
      else set_IC_ENFORE_ALPHANUMERIC(checkMarkFalse);

      //checks small letter count
      if (parseInt(NUM_SMALL_CHAR) > 0) {
        let smallLetter = /[a-z]/;
        let smallLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (smallLetter.test(Newpassword.charAt(position))) {
            smallLetterCount += 1;
          }
        }
        if (parseInt(NUM_SMALL_CHAR) > smallLetterCount)
          set_IC_NUM_SMALL_CHAR(checkMarkFalse);
        else set_IC_NUM_SMALL_CHAR(checkMarkCorrect);
      }
      //checks capital letter count
      if (parseInt(NUM_CAPITAL_CHAR) > 0) {
        let capitalLetter = /[A-Z]/;
        let capitalLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (capitalLetter.test(Newpassword.charAt(position))) {
            capitalLetterCount += 1;
          }
        }
        if (parseInt(NUM_CAPITAL_CHAR) > capitalLetterCount)
          set_IC_NUM_CAPITAL_CHAR(checkMarkFalse);
        else set_IC_NUM_CAPITAL_CHAR(checkMarkCorrect);
      }

      //checks special letter count
      if (parseInt(NUM_SPECIAL_CHAR) > 0) {
        let specialLetterCount = 0;
        for (let position = 0; position < Newpassword.length; position++) {
          if (specialFormat.test(Newpassword.charAt(position))) {
            specialLetterCount += 1;
          }
        }
        if (parseInt(NUM_SPECIAL_CHAR) > specialLetterCount)
          set_IC_NUM_SPECIAL_CHAR(checkMarkFalse);
        else set_IC_NUM_SPECIAL_CHAR(checkMarkCorrect);
      }
    } else {
      if (IC_ENFORCE_START_WITH_ALPHA === checkMarkCorrect) {
        set_IC_NUM_SMALL_CHAR(checkMarkFalse);
        set_IC_NUM_CAPITAL_CHAR(checkMarkFalse);
        set_IC_NUM_SPECIAL_CHAR(checkMarkFalse);
        set_IC_ENFORCE_START_WITH_ALPHA(checkMarkFalse);
        set_IC_ENFORCE_SPECIAL_CHAR(checkMarkFalse);
        set_IC_ENFORE_ALPHANUMERIC(checkMarkFalse);
      }
    }
  }

  function validateForResetPassword() {
    if (
      newPassword.length === 0 ||
      newPassword === "" ||
      newPassword === null
    ) {
      Helpers.errorNotify(t("New_Password_is_required"), i18next.language);
      return false;
    }

    if (
      confirmNewPassword.length === 0 ||
      confirmNewPassword === "" ||
      confirmNewPassword === null
    ) {
      Helpers.errorNotify(
        t("Confirm_New_Password_is_required"),
        i18next.language
      );
      return false;
    }

    if (confirmNewPassword !== newPassword) {
      Helpers.errorNotify(
        t("passwordnotmatchconfirmedpassword"),
        i18next.language
      );
      return false;
    }

    if (MINLENGTH !== "" && IC_MINLENGTH === checkMarkFalse) {
      // Helpers.errorNotify(
      //   t("passwordtooshort") + " " + MINLENGTH,
      //   i18next.language
      // );
            Helpers.errorNotify(t("passwordtooshort", { min: MINLENGTH }),i18next.language);

      return false;
    }

    if (
      ENFORCE_START_WITH_ALPHA !== "" &&
      IC_ENFORCE_START_WITH_ALPHA === checkMarkFalse
    ) {
      Helpers.errorNotify(t("passwordcantstartno"), i18next.language);
      return false;
    }

    if (
      NUM_SPECIAL_CHAR !== "" &&
      NUM_SPECIAL_CHAR !== "0" &&
      IC_NUM_SPECIAL_CHAR === checkMarkFalse &&
      ENFORCE_SPECIAL_CHAR === "Y"
    ) {
      Helpers.errorNotify(
        format(
          t("passwordcountspecialchar_X0"),
          NUM_SPECIAL_CHAR
        ),
        i18next.language
      );
      return false;
    }

    if (
    
      IC_ENFORE_ALPHANUMERIC === checkMarkFalse &&
      ENFORE_ALPHANUMERIC === "Y"
    ) {
      Helpers.errorNotify(
        t("ENFORE_ALPHANUMERIC"),
        i18next.language
      );
      return false;
    }

    if (
      ENFORCE_SPECIAL_CHAR !== "" &&
      ENFORCE_SPECIAL_CHAR === "Y" &&
      IC_ENFORCE_SPECIAL_CHAR === checkMarkFalse && 
       localStorage.getItem(Constants.localStorageConstants.company_name) !==
        "BHM"
    ) {
      localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "ALRAMZ"
        ? Helpers.errorNotify(
          t("passwordEnforceSpecialCharALRAMZ"),
          i18next.language
        )
        : Helpers.errorNotify(
          t("passwordEnforceSpecialChar"),
          i18next.language
        );
      return false;
    }
    if (
      NUM_SMALL_CHAR !== "" &&
      NUM_SMALL_CHAR !== "0" &&
      IC_NUM_SMALL_CHAR === checkMarkFalse
    ) {
      Helpers.errorNotify(
        format(t("passwordcountsmallchar_X0"), NUM_SMALL_CHAR), i18next.language
      );
      return false;
    }

    if (
      NUM_CAPITAL_CHAR !== "" &&
      NUM_CAPITAL_CHAR !== "0" &&
      IC_NUM_CAPITAL_CHAR === checkMarkFalse
    ) {
      Helpers.errorNotify(
        format(
          t("passwordcountcapitalchar_X0"),
          NUM_CAPITAL_CHAR
        ),
        i18next.language
      );
      return false;
    }

    return true;
  }

  // const errorNotify = (message) => {
  //     toast.error(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.errorNotifyDuration
  //     });
  // };

  // const successNotify = (message) => {
  //     toast.success(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.successNotifyDuration
  //     });
  // };
  console.log("isNewPasswordVisible", isNewPasswordVisible);

  const callLogOff = () => {
    //
    // props.setIsLoaderVisible(true);
    //console.log("logging out...");
    let logOffResponse = utils.logOff();
    logOffResponse
      .then((response) => {
        // props.setIsLoaderVisible(false);
        //console.log("Logged Off", response)
        // if (response.status === 200) {
        localStorage.removeItem("user");
        localStorage.removeItem("ExpiredDocument");
        let UserName = localStorage.getItem("username");
        let RememberMe = localStorage.getItem("isRememberMe");
        let language = localStorage.getItem("language");

        let Comapnyname = localStorage.getItem(
          Constants.localStorageConstants.company_name
        );
        var prev = Helpers.getPreviousConfig();
        if (RememberMe === "true") {
          localStorage.clear();
          localStorage.setItem("isRememberMe", true);
          localStorage.setItem("username", UserName);
          localStorage.setItem("language", language);

          localStorage.setItem(
            Constants.localStorageConstants.company_name,
            Comapnyname
          );
        } else {
          localStorage.clear();
          localStorage.setItem("language", language);

          localStorage.setItem(
            Constants.localStorageConstants.company_name,
            Comapnyname
          );
        }
        Helpers.SetpreviosConfig(prev);
        setRedirect(AppUrls.login);
        //   setState({ redirect: AppUrls.login }, () => {
        //     disconnectSignalr();
        //   });
        //}
      })
      .catch((error) => {
        //props.setIsLoaderVisible(false);
        //console.log("error", error);
      });
  };
  return (
    <div className="AuthCont">
      <form name="form" className="ForgotPasswordForm">
        <div className="center">
          {!isNewPasswordVisible ? (
            localStorage.getItem("ForgotPasswordMethod") === "O" ? (
              <>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="text"
                    name="nin"
                    placeholder={t("TradingNumber")}
                    value={nin}
                    onChange={(e) => {
                      e.preventDefault();
                      setNin(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="mobile"
                    name="mobile"
                    placeholder={t("mobileNo")}
                    value={mobile}
                    onChange={(e) => {
                      e.preventDefault();
                      setMobile(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : localStorage.getItem("ForgotPasswordMethod") === "S" ? (
              <>
                {localStorage
                  .getItem(Constants.localStorageConstants.company_name)
                  .toUpperCase() === "IFS" ? (
                  <div className="form-group">
                    <input
                      className="input-textbox"
                      type="text"
                      name="username"
                      placeholder={t("usernamePlaceholder")}
                      value={username}
                      onChange={(e) => {
                        e.preventDefault();
                        setUsername(e.target.value);
                      }}
                    />
                  </div>
                ) : null}
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="email"
                    name="email"
                    placeholder={t("email")}
                    value={email}
                    onChange={(e) => {
                      e.preventDefault();
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="mobile"
                    name="mobile"
                    placeholder={t("mobileNo")}
                    value={mobile}
                    onChange={(e) => {
                      e.preventDefault();
                      setMobile(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : localStorage.getItem("ForgotPasswordMethod") === "U" ||
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "SIFS" ? (
              <>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="text"
                    name="username"
                    placeholder={t("usernamePlaceholder")}
                    value={username}
                    onKeyDown={(e) => {
                      const charCode = e.key.charCodeAt(0);
                      if (charCode >= 0x0600 && charCode <= 0x06ff) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      e.preventDefault();
                      setUsername(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : localStorage.getItem("ForgotPasswordMethod") === "C" ? (
              <>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="text"
                    name="nin"
                    placeholder={t("nin")}
                    value={nin}
                    onChange={(e) => {
                      e.preventDefault();
                      setNin(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="input-textbox"
                    type="text"
                    name="IdNumber"
                    placeholder={t("IdNumber")}
                    value={qId}
                    onChange={(e) => {
                      e.preventDefault();
                      setQId(e.target.value);
                    }}
                  />
                </div>
              </>
            )

              : localStorage.getItem("ForgotPasswordMethod") === "UE" ?
                (
                  <>
                    <div className="form-group">
                      <input
                        className="input-textbox"
                        type="text"
                        name="username"
                        placeholder={t("usernamePlaceholder")}
                        value={username}
                        onKeyDown={(e) => {
                          const charCode = e.key.charCodeAt(0);
                          if (charCode >= 0x0600 && charCode <= 0x06ff) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          e.preventDefault();
                          setUsername(e.target.value);
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <input
                        className="input-textbox"
                        type="email"
                        name="email"
                        placeholder={t("email")}
                        value={email}
                        onChange={(e) => {
                          e.preventDefault();
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                  </>
                )
                : (
                  <>
                    <div className="form-group">
                      <input
                        className="input-textbox"
                        type="email"
                        name="email"
                        placeholder={t("email")}
                        value={email}
                        onChange={(e) => {
                          e.preventDefault();
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        className="input-textbox"
                        type="mobile"
                        name="mobile"
                        placeholder={t("mobileNo")}
                        value={mobile}
                        onChange={(e) => {
                          e.preventDefault();
                          setMobile(e.target.value);
                        }}
                      />
                    </div>
                  </>
                )
          ) : (
            <>
              <div>
                <div
                  className="form-group container-input-with-password"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <input
                    className="input-textbox"
                    type={NewPasswordType}
                    name="newPassword"
                    placeholder={t("enter_new_password")}
                    value={newPassword}
                    onChange={(e) => {
                      e.preventDefault();
                      onChangeNewPassword(e);
                    }}
                    onKeyDown={(e) => {
                      const charCode = e.key.charCodeAt(0);
                      if (charCode >= 0x0600 && charCode <= 0x06ff) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <i
                    className={
                      NewPasswordType === "password"
                        ? "fa fa-eye-slash"
                        : "fa fa-eye"
                    }
                    aria-hidden="true"
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      // right: i18next.language === "en" ? "250px" : "",
                      // left: i18next.language === "en" ? "" : "250px",
                      position: "absolute",
                      top: "20px",
                      color: "black",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (NewPasswordType === "password") {
                        setNewPasswordType("text");
                      } else {
                        setNewPasswordType("password");
                      }
                    }}
                  ></i>
                </div>
                <div
                  className="form-group container-input-with-password"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <input
                    className="input-textbox"
                    type={ConfirmPasswordType}
                    name="confirmPassword"
                    placeholder={t("enter_confirm_new_password")}
                    value={confirmNewPassword}
                    onChange={(e) => {
                      e.preventDefault();
                      setConfirmNewPassword(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      const charCode = e.key.charCodeAt(0);
                      if (charCode >= 0x0600 && charCode <= 0x06ff) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <i
                    className={
                      ConfirmPasswordType === "password"
                        ? "fa fa-eye-slash"
                        : "fa fa-eye"
                    }
                    aria-hidden="true"
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      // right: i18next.language === "en" ? "250px" : "",
                      // left: i18next.language === "en" ? "" : "250px",
                      position: "absolute",
                      top: "20px",
                      color: "black",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (ConfirmPasswordType === "password") {
                        setConfirmPasswordType("text");
                      } else {
                        setConfirmPasswordType("password");
                      }
                    }}
                  ></i>
                </div>
                <div
                  className="mt-3"
                  style={{ float: leftLocalized, textAlign: leftLocalized }}
                >
                  {MINLENGTH !== "" ? (
                    <div>
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_MINLENGTH}
                        alt=""
                      />
                      <span>{t("passwordtooshort") + " " + MINLENGTH}</span>
                    </div>
                  ) : null}
                  {ENFORCE_START_WITH_ALPHA !== "" &&
                    ENFORCE_START_WITH_ALPHA === "Y" ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_ENFORCE_START_WITH_ALPHA}
                        alt=""
                      />
                      <span>{t("passwordcantstartno")}</span>
                    </div>
                  ) : null}
                  {ENFORE_ALPHANUMERIC !== "" &&
                    ENFORE_ALPHANUMERIC === "Y" ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_ENFORE_ALPHANUMERIC}
                        alt=""
                      />
                      <span>{t("ENFORE_ALPHANUMERIC")}</span>
                    </div>
                  ) : null}
                  {ENFORCE_SPECIAL_CHAR !== "" &&
                    ENFORCE_SPECIAL_CHAR === "Y" &&  
                    localStorage.getItem(
                        Constants.localStorageConstants.company_name
                      ) !== "BHM" ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_ENFORCE_SPECIAL_CHAR}
                        alt=""
                      />
                      {localStorage.getItem(
                        Constants.localStorageConstants.company_name
                      ) === "ALRAMZ" ? (
                        <span>{t("passwordEnforceSpecialCharALRAMZ")}</span>
                      ) : (
                        <span>{t("passwordEnforceSpecialChar")}</span>
                      )}
                    </div>
                  ) : null}
                  {NUM_SMALL_CHAR !== "" && parseInt(NUM_SMALL_CHAR) > 0 ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_NUM_SMALL_CHAR}
                        alt=""
                      />
                      <span>
                        {format(t("passwordcountsmallchar_X0"), NUM_SMALL_CHAR)}
                      </span>
                    </div>
                  ) : null}
                  {NUM_CAPITAL_CHAR !== "" && parseInt(NUM_CAPITAL_CHAR) > 0 ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_NUM_CAPITAL_CHAR}
                        alt=""
                      />
                      <span>
                        {format(
                          t("passwordcountcapitalchar_X0"),
                          NUM_CAPITAL_CHAR
                        )}
                      </span>
                    </div>
                  ) : null}
                  {NUM_SPECIAL_CHAR !== "" &&
                    parseInt(NUM_SPECIAL_CHAR) > 0 &&
                    ENFORCE_SPECIAL_CHAR === "Y" ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={IC_NUM_SPECIAL_CHAR}
                        alt=""
                      />
                      <span>
                        {format(
                          t("passwordcountspecialchar_X0"),
                          NUM_SPECIAL_CHAR
                        )}
                      </span>
                    </div>
                  ) : null}
                  {Constants.config.CompanyName === "CIC" ? (
                    <div className="mt-1">
                      <img
                        className={mr2Localized + " check-mark"}
                        src={checkMarkFalse}
                        alt=""
                      />
                      <span>{t("secondpasswordpolicy")}</span>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="form-group form-group-btns center">
          {!isNewPasswordVisible ? (
            <button
              className="auth-btns btn btn-primary customBtn "
              style={{ width: "100%" }}
              onClick={(e) => {
                e.preventDefault();
                callUserAuthinticationAdvance();
              }}
            >
              {t("request")}
            </button>
          ) : (
            <button
              className="auth-btns btn btn-primary  customBtn  mt-3"
              style={{ width: "100%" }}
              onClick={(e) => {
                e.preventDefault();
                callResetPassword();
              }}
            >
              {t("changePassword")}
            </button>
          )}
        </div>
        <div>
          <button
            className={"link WelcomeMessageDiv"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={(event) => {
              event.preventDefault();
              callLogOff();
              // setRedirect(AppUrls.login);
              //   localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) : setRedirect(AppUrls.login);
            }}
          >
            {t("cancelForgotPassword")}
          </button>
        </div>
      </form>
      {localStorage.getItem(Constants.localStorageConstants.company_name) !==
        "SIFS" ? (
        <div
          className={"center-loader loaderCss  " + hideLoader}
          style={{ backgroundColor: "#FFFFFFD9" }}
        >
          <Loader
            type="Bars"
            color="#00BFFF"
            height={100}
            width={100}
            visible={visible}
          />
        </div>
      ) : (
        <div
          className={" center-loader " + hideLoader}
          style={{ height: "100%", width: "100%" }}
        >
          <SpinnersLoadingSIP />
        </div>
      )}
    </div>
  );
}

export default ForgetPassword;
